<script>

    export default {

        inject: [
            '$pageComponent',
            'options',
        ],

        provide()
        {
            return {
                $pageComponent: this.$pageComponent,
                options: this.options,
            };
        },

        data()
        {
            return {

                // Copy options to loose reactivity?
                options: this.options !== null ? this.options : JSON.parse(JSON.stringify(this.$pageComponent().selection.currentSelection.canvasBlock.options)),
            };
        },

        methods:
        {
            /**
             * TODO Since we save now by manual interaction, we don't need to listen changes of the canvas to auto-save. Remove auto-save?
             */
            save()
            {
                // Save by moving new options into canvas block.
                this.canvasBlock.options = this.options;
            },
        },

        computed: {

            canvasBlock()
            {
                return this.editorComponent.canvasBlock;
            },

            editorComponent()
            {
                return this.$pageComponent().selection.currentSelection;
            },

            pageComponent()
            {
                return this.$pageComponent();
            },

            adminUrlPrefix()
            {
                return '/'+ ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') +'canvas-editor/' + this.pageComponent.state.canvasVersion.id + '/blocks/' + this.canvasBlock.block.replace('.', '/');
            },

        }

    }

</script>